module.exports = __webpack_public_path__ + "img/pic_grid_new.f37b14ae.png";